// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LcXi","label":"styles_label__DV7gR"};